import React from 'react';

const ConsentIntro: React.FC = () => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="consent-intro">
          Voice transcribing consent
        </label>
      </h1>
      <div className="govuk-body">
        I will be using an ambient scribe to help me document your wishes after
        asking you the following questions. This is a tool that will
        automatically convert what you say into text. We are unable to save a
        recording of the audio. I will then review the transcription and make
        any changes that you would like to be changed. It will then be saved as
        text. Transcribing helps us create better and more detailed Advance Care
        Plans.
      </div>
    </div>
  );
};

export default ConsentIntro;
